
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { useTranslations } from "@/hooks/useTranslations";

interface ExerciseInstructionsProps {
  instructions?: string[];
  isOpen?: boolean;
}

export function ExerciseInstructions({ instructions, isOpen = false }: ExerciseInstructionsProps) {
  const [open, setOpen] = useState(isOpen);
  const { t } = useTranslations("workouts");
  
  if (!instructions || instructions.length === 0) {
    return null;
  }

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="w-full">
      <div className="flex items-center gap-1">
        <CollapsibleTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 px-2 text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white">
            <ChevronRight className={`h-4 w-4 transition-transform ${open ? 'rotate-90' : ''}`} />
            <span className="text-sm font-medium mr-1">{t("exercises.instructions")}</span>
          </Button>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent className="px-4 pt-2 pb-2 space-y-2 dark:bg-gray-800/50 rounded-md">
        {instructions.map((instruction, index) => (
          <p key={index} className="text-sm text-slate-600 dark:text-slate-300">
            {index + 1}. {instruction}
          </p>
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}
